import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import './App.css'
import { HomePage } from './pages/home'
import './i18n'
import { useIsUSA } from './hooks'
import { ConfigureMicrosoftPage } from './pages/microsoft'
import { ConfigureGooglePage } from './pages/google'

function App() {
  const isAllowed = useIsUSA()

  return (
    <div className='App'>
      <Routes>
        <Route index element={<HomePage isAllowed={isAllowed} />} />
        <Route path='/configure_microsoft' element={<ConfigureMicrosoftPage isAllowed={isAllowed} />} />
        <Route path='/configure_google' element={<ConfigureGooglePage isAllowed={isAllowed} />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </div>
  )
}

export default App
